module.exports = __webpack_public_path__ + "assets/webgl/card_109_EN_L0.jpg.6cc64efd.webp";